// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0751d550","498":"e4adf0f0","703":"32e40676"}[chunkId] + ".chunk.js";
};